import isEmpty from '../../utility/isEmpty'

export default {
  processAddresses (state) {
    return function (addresses) {
      if (!isEmpty(addresses)) {
        addresses.reduce((acc, element) => { // Ensure the 'Home' address is the first in the list
          if (element.typeName === 'Home') { // TODO: Worry about this changing with localization changes (could pull from a lang file)
            return [element, ...acc]
          }

          return [...acc, element]
        }, [])

        for (let i = 0; i < addresses.length; i++) {
          addresses[i].display = true
          addresses[i].sameAddresses = false
          addresses[i].index = i
        }
      }

      return addresses
    }
  },

  /**
   * Returns the NLS Customer ID if one is available.
   * @param {Object} state - The current Vuex customer state values.
   */
  nlsCustomerId (state) {
    return !isEmpty(state.customerIds) && !isEmpty(state.lmsReferenceIds) && !isEmpty(state.lmsReferenceIds.NLS) && !isEmpty(state.customerIds[state.lmsReferenceIds.NLS]) ? state.customerIds[state.lmsReferenceIds.NLS] : undefined
  },

  /**
   * Returns the TLXe Customer ID if one is available.
   * @param {Object} state - The current Vuex customer state values.
   */
  tlxeCustomerId (state) {
    return !isEmpty(state.customerIds) && !isEmpty(state.lmsReferenceIds) && !isEmpty(state.lmsReferenceIds.TLXe) && !isEmpty(state.customerIds[state.lmsReferenceIds.TLXe]) ? state.customerIds[state.lmsReferenceIds.TLXe] : undefined
  },

  /**
   * Returns the Invictus Customer ID if one is available.
   * @param {Object} state - The current Vuex customer state values.
   */
  invictusCustomerId (state) {
    return !isEmpty(state.customerIds) && !isEmpty(state.lmsReferenceIds) && !isEmpty(state.lmsReferenceIds.Invictus) && !isEmpty(state.customerIds[state.lmsReferenceIds.Invictus]) ? state.customerIds[state.lmsReferenceIds.Invictus] : undefined
  },

  /**
   * Checks to see if the user only has an NLS customer ID. If no Customer IDs exist, no LMS Reference IDs exist, or if a TLXe customer ID does exist, false is returned.
   * @param {Object} state - The current Vuex customer state values.
   * @param {Object} getters - The current Vuex store's getters.
   */
  isOnlyNlsUser (state, getters) {
    return getters.isNlsUser && !getters.isTlxeUser
  },

  /**
   * Checks to see if the user only has a TLXe customer ID. If no Customer IDs exist, no LMS Reference IDs exist, or if a NLS customer ID does exist, false is returned.
   * @param {Object} state - The current Vuex customer state values.
   * @param {Object} getters - The current Vuex store's getters.
   */
  isOnlyTlxeUser (state, getters) {
    return getters.isTlxeUser && !getters.isNlsUser
  },

  /**
   * Checks to see if the user only has a TLXe customer ID. If no Customer IDs exist or no LMS Reference IDs exist, false is returned.
   * @param {Object} state - The current Vuex customer state values.
   * @param {Object} getters - The current Vuex store's getters.
   */
  isTlxeUser (state, getters) {
    return !isEmpty(getters.tlxeCustomerId)
  },

  /**
   * Checks to see if the user has a NLS customer ID. If no Customer IDs exist or no LMS Reference IDs exist, false is returned.
   * @param {Object} state - The current Vuex customer state values.
   * @param {Object} getters - The current Vuex store's getters.
   */
  isNlsUser (state, getters) {
    return !isEmpty(getters.nlsCustomerId)
  },

  /**
   * Checks to see if the user has a Invictus customer ID. If no Customer IDs exist or no LMS Reference IDs exist, false is returned.
   * @param {Object} state - The current Vuex customer state values.
   * @param {Object} getters - The current Vuex store's getters.
   */
  isInvictusUser (state, getters) {
    return !isEmpty(getters.invictusCustomerId)
  },

  /**
   * Validate the stored names with the passed in name.
   *
   * Normalizing and doing indexOf and character checks allows us to handle:
   * 1) multi-name first and last names
   * 2) customers who's middle name is on the card
   * 3) customers who have suffixes (Jr, Sr, III, etc.) on their card
   * 4) more 'traditional' first/last name combos
   * NOTE:  this.firstName and this.lastName come from the server and are never change
   * @param {Object} state - The current Vuex customer state values.
   * @returns {firstNameMatches: Boolean, lastNameMatches: Boolean} Whether the first and last name match the passed in name.
   */
  validateName (state) {
    return (name) => {
      const enteredName = name.toLowerCase() // normalize
      const indexOfFirstName = enteredName.indexOf(state.customerFirstName.toLowerCase())
      const nextIndexFirstName = indexOfFirstName + state.customerFirstName.length

      const indexOfLastName = enteredName.lastIndexOf(state.customerLastName.toLowerCase())
      const nextIndexLastName = indexOfLastName + state.customerLastName.length

      const firstNameMatches = (indexOfFirstName > -1) && (indexOfFirstName < indexOfLastName) && enteredName[nextIndexFirstName] === ' '
      const lastNameMatches = (indexOfLastName > -1) && (indexOfFirstName < indexOfLastName) && (enteredName[nextIndexLastName] === ' ' || isEmpty(enteredName[nextIndexLastName]))

      return {
        firstNameMatches,
        lastNameMatches
      }
    }
  },

  isNonCustomer (state) {
    return isEmpty(state.customerIds)
  },

  isNewProfile (state, getters, rootState, rootGetters) {
    return isEmpty(state.customerIds) && !rootState.referral.ncrCognitoAttribute
  },

  /**
   * Gets the referral URL from stored customer info.
   * @param {Object} state - The current Vuex customer state values
   * @returns {String} The BirdEye referral URL.
   */
  getReferralUrl (state) {
    return !isEmpty(state.referralInfo) ? state.referralInfo.url : undefined
  },

  customerEmail (state, getters, rootState) {
    return !isEmpty(state.email) ? state.email : rootState.session.email
  }
}
